<script>
import Datalayer from 'Controllers/Web/Datalayer';
import 'lazysizes';
import RecommendCourseComponent from 'Vue/Web/Common/RecommendCourseComponent.vue';
import HomePageProductComponent from 'Vue/Web/Common/HomePageProductComponent.vue';
import HomePageNoteComponent from 'Vue/Web/Common/HomePageNoteComponent.vue';
import HomeBanner from 'Vue/Web/HomeBanner.vue';

export default {
  name: 'HomePageController',
  el: '.wrap',
    components: {
        Datalayer,
        RecommendCourseComponent,
        HomePageProductComponent,
        HomePageNoteComponent,
        HomeBanner
    },
  props: {
  },
  mounted() {
  },
  data() {
    return {
        IndexAdvertising: Json.IndexAdvertising,
    }},
  methods: {
    async handleClick(event, title, position) {
      event.preventDefault();
      await Datalayer.storeDatalayerEvent(title, position);
      window.location.href = event.target.href;
    },
  }
};
</script>

<style scoped>

</style>
